import { DOCUMENT } from '@angular/common';
import { Component, Inject, ElementRef, OnInit, Renderer2, HostListener, NgZone } from '@angular/core';
import { ROUTES, NEAR_MISS_ROUTES } from './sidebar-items';
import { NewAuditService } from 'src/app/services/new-audit.service';
import { UserService } from 'src/app/services/user.service';
import { NewIncidentService } from 'src/app/services/new-incident.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslateService } from "@ngx-translate/core";

@Component({

  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  public sidebarItems: any[];
  showMenu: string = '';
  showSubMenu: string = '';
  public innerHeight: any;
  public bodyTag: any;
  listMaxHeight: string;
  listMaxWidth: string;
  headerHeight = 60;

  showSideBar = false;
  menuToggleOff: boolean = false;
  incident: number;
  nearMiss: number;
  selectedlang;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private newAuditService: NewAuditService,
    private newIncidentService: NewIncidentService,
    private userService: UserService,
    private translateService: TranslateService,
    private router: Router,
    private ngZone: NgZone
  ) {
    this.translateService.setDefaultLang('en');

    this.selectedlang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
    this.translateService.use(this.selectedlang);

    router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (event.url.includes('home')) {
        this.showSideBar = false;
      } else {
        this.showSideBar = true;
      }
      const incidentValue = localStorage.getItem('isIncidentEnabled');
      const nearMissValue = localStorage.getItem('isNearMissEnabled');
      this.incident = (incidentValue && incidentValue !== 'undefined') ? JSON.parse(incidentValue) : 0;
      this.nearMiss = (nearMissValue && nearMissValue !== 'undefined') ? JSON.parse(nearMissValue) : 0;
      this.setSideBarItems(this.incident, this.nearMiss);
      
      // Near Miss routes - show menu items based on role
      if (event.url.includes('near-miss')) {
        this.loadNearMissMenuByRole();
      } else if (event.url.includes('incident')) {
        const isMobile = localStorage.getItem("ismobile") ? JSON.parse(localStorage.getItem("ismobile")) : false;
        if (isMobile) {
          ROUTES.forEach((item) => {
            if (item.title.toLowerCase() == 'Home'.toLowerCase()) {
              item.path = '/incidents';
            }
          }
          );
          this.sidebarItems = ROUTES.filter((item) => 
            item.path !== '/create-new-audit' && 
            item.title.toLowerCase() !== 'Near Miss'.toLowerCase()
          );
          // Close sidebar on mobile devices
          this.renderer.addClass(this.document.body, 'ls-closed');
          this.renderer.removeClass(this.document.body, 'overlay-open');
        } else {
          this.sidebarItems = ROUTES.filter((item) => 
            item.path !== '/create-new-audit' && 
            item.title.toLowerCase() !== 'Near Miss'.toLowerCase()
          );
        }
      } else if (event.url.includes('audit')) {
        const issso = localStorage.getItem("isauditonly") !== undefined ? JSON.parse(localStorage.getItem("isauditonly")) : null;
        if (issso) {
          ROUTES.forEach((item) => {
            if (item.title.toLowerCase() == 'Home'.toLowerCase()) {
              item.path = '/audits';
            }
          }
          );
        }
        // Filter out Near Miss menu from Audits module
        this.sidebarItems = ROUTES.filter((item) => {
          if (this.incident === 0 && item.title.toLowerCase() === 'Log Incident'.toLowerCase()) {
            return false;
          }
          if (item.title.toLowerCase() === 'Near Miss'.toLowerCase()) {
            return false;
          }
          return true;
        });
      } else if (event.url.includes('notification') || event.url.includes('authentication')) {
        this.sidebarItems = ROUTES.filter((item) => {
          if (this.incident === 0 && item.title.toLowerCase() === 'Log Incident'.toLowerCase()) {
            return false;
          }
          if (this.nearMiss === 0 && item.title.toLowerCase() === 'Near Miss'.toLowerCase()) {
            return false;
          }
          return true;
        });
      } else {
        this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
      }
      if (event.url.includes('incident') || event.url.includes('create-new-audit')) {
        this.sidebarItems.find(item => item?.title === 'Help').showMenu = '';
      }
    });
    this.newIncidentService.menuToggle.subscribe(response => {
      if (!this.sidebarItems && !this.sidebarItems?.length) {
        ROUTES[1].menuToggleOff = response;
      } else {
        this.sidebarItems[1].menuToggleOff = response;
      }
      this.menuToggleOff = response;
      if (response === false) {

        this.newIncidentService.actionTabExist.subscribe(tabExist => {
          if (tabExist === true && router.url.includes('incident')) {
            this.sidebarItems[1].submenu = [
              {
                path: '/create-new-incident/questionnaire',
                title: 'Questionnaire',
                icon: '',
                class: '',
                submenu: [],
              },
              {
                path: '/create-new-incident/incident-action',
                title: 'Action',
                icon: '',
                class: '',
                submenu: [],
              },
              {
                path: '/create-new-incident/signature',
                title: 'Signature',
                icon: '',
                class: '',
                submenu: [],
              },
              {
                path: '/create-new-incident/assign-submit',
                title: 'Assign & Submit',
                icon: '',
                class: '',
                submenu: [],
              },
            ]
          } else {
            if (this.sidebarItems && this.sidebarItems.length) {
              this.sidebarItems[1].submenu = this.sidebarItems[1].submenu.filter((item) => item.title !== 'Action');
              this.sidebarItems.find(item => item?.title === 'Help').class = 'menu-toggle';
            }
          }
        })
        setTimeout(() => {
          if (!this.sidebarItems && !this.sidebarItems?.length) {
            ROUTES.find(item => item?.title === 'Help').class = 'menu-toggle';

          } else {
            this.sidebarItems.find(item => item?.title === 'Help').class = 'menu-toggle';

          }
        }, 2000)

      }
    })
  }

  setSideBarItems(incident, nearMiss): void {
    // Don't modify sidebar if we're in Near Miss module
    const currentUrl = this.router.url;
    if (currentUrl.includes('near-miss')) {
      return;
    }
    
    if (incident === 0 && nearMiss === 0) {
      // Both disabled - show only audits
      ROUTES.forEach(route => {
        if (route.title.toLowerCase() === 'home') {
          route.path = '/audits'
        }
      })
      this.sidebarItems = ROUTES.filter((item) => 
        item.title.toLowerCase() !== 'Log Incident'.toLowerCase() && 
        item.title.toLowerCase() !== 'Near Miss'.toLowerCase()
      );
    } else if (incident === 0 && nearMiss !== 0) {
      // Only incidents disabled - show audits and near miss
      this.sidebarItems = ROUTES.filter((item) => item.title.toLowerCase() !== 'Log Incident'.toLowerCase());
    } else if (incident !== 0 && nearMiss === 0) {
      // Only near miss disabled - show audits and incidents
      this.sidebarItems = ROUTES.filter((item) => item.title.toLowerCase() !== 'Near Miss'.toLowerCase());
    } else {
      // Both enabled - show all items
      this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
    }
  }

  @HostListener('window:resize', ['$event'])
  windowResizecall(_event) {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, 'overlay-open');
    }
  }

  callMenuToggle(event: any, element: any, sidebarItem: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
    sidebarItem.showMenu = sidebarItem.showMenu !== '' ? '' : element;
    if (element !== 'Help') {
      const hasClass = event.target.classList.contains('toggled');
      if (hasClass) {
        this.renderer.removeClass(event.target, 'toggled');
      } else {
        this.renderer.addClass(event.target, 'toggled');
      }
    }
    localStorage.setItem('autologindata', '');
    if (element == 'Start New Audit') {
      const user = JSON.parse(localStorage.getItem('user'));
      this.userService.updateUserDetailsToCurrentUser(user);

      this.newAuditService.setAuditEdited(false);
      this.newIncidentService.setMenuToggleOff(true);
      localStorage.setItem('schedule', '');
      localStorage.setItem('autologindata', '');
      localStorage.setItem('audit', '');
      localStorage.setItem("row_status", '');
      this.sidebarItems[1].menuToggleOff = true;
      this.sidebarItems.find(item => item?.title === 'Help').showMenu = '';
    }
    if (element == 'Log Incident') {
      this.sidebarItems.find(item => item?.title === 'Help').showMenu = '';
    }
    
    // Close menu on mobile devices
    const isMobile = this.checkIfMobile();
    if (isMobile && element !== 'Help') {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.ngZone.run(() => {
            this.renderer.addClass(this.document.body, 'ls-closed');
            this.renderer.removeClass(this.document.body, 'overlay-open');
          });
        }, 50);
      });
    }
  }

  callSubMenuToggle(element: any) {
    if (element == 'Help Center') {
      window.open('https://support.goaudits.com/en/');
    } else if (element === "Terms & Conditions" || element === "Privacy Policy") {
      localStorage.setItem('helpItem', element)
      this.router.navigate(['/authentication/help', element]);
    }
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
    
    // Close menu on mobile devices when submenu item is clicked
    const isMobile = this.checkIfMobile();
    if (isMobile) {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.ngZone.run(() => {
            this.renderer.addClass(this.document.body, 'ls-closed');
            this.renderer.removeClass(this.document.body, 'overlay-open');
          });
        }, 50);
      });
    }
  }

  ngOnInit() {
    const incidentValue = localStorage.getItem('isIncidentEnabled');
    const nearMissValue = localStorage.getItem('isNearMissEnabled');
    this.incident = (incidentValue && incidentValue !== 'undefined') ? JSON.parse(incidentValue) : 0;
    this.nearMiss = (nearMissValue && nearMissValue !== 'undefined') ? JSON.parse(nearMissValue) : 0;
    
    // Check current URL to set appropriate sidebar items
    const currentUrl = this.router.url;
    if (currentUrl.includes('near-miss')) {
      this.loadNearMissMenuByRole();
    } else {
      this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
      this.setSideBarItems(this.incident, this.nearMiss);
    }

    // this.activateLinks();
    this.newAuditService.getAuditCreated().subscribe((x) => {
      //console.log("valset",x)
      //  if(x)
      this.activateAuditLinks(x);
    });

    this.newIncidentService.getIncidentCreated().subscribe((x) => {
      //console.log("valset",x)
      //  if(x)
      this.activateIncidentLinks(x);
    });

    //console.log(this.sidebarItems);

    this.initLeftSidebar();
    this.bodyTag = this.document.body;
  }

  activateAuditLinks(y) {
    // var audit = JSON.parse( localStorage.getItem('audit'));
    this.sidebarItems.forEach((x) => {
      //console.log(x);
      if (!y) {
        if (x.path === 'Questionnaire' || x.path === 'Signature' || x.path === 'Preview') {
          x.isDisabled = true;
          x.class = 'disablLink';
        }
      } else x.class = '';
    });
  }

  activateIncidentLinks(y) {
    this.sidebarItems.forEach((x) => {
      if (!y) {
        // if (x.path === '/create-new-incident' || x.path === '/create-new-incident/category') {
        //   x.submenu.forEach((sub) => {
        //     if (
        //       sub.path === '/create-new-incident/questionnaire' ||
        //       sub.path === '/create-new-incident/signature' ||
        //       sub.path === '/create-new-incident/assign-submit'
        //     ) {
        //       sub.isDisabled = true;
        //       sub.class = 'disablLink';
        //     }
        //   });
        // }
        if (x.path === 'Questionnaire' || x.path === 'Signature' || x.path === 'Assign & Submit' || x.path === 'Action') {
          x.isDisabled = true;
          x.class = 'disablLink';
        }
      } else {
        x.class = '';

        // x.submenu.forEach((sub) => {
        //   if (
        //     sub.path === '/create-new-incident/questionnaire' ||
        //     sub.path === '/create-new-incident/signature' ||
        //     sub.path === '/create-new-incident/assign-submit'
        //   ) {
        //     sub.isDisabled = false;
        //     sub.class = '';
        //   }
        // });
      }
    });
  }

  initLeftSidebar() {
    this.setMenuHeight();
    this.checkStatuForResize(true);
  }

  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + '';
    this.listMaxWidth = '500px';
  }

  isOpen() {
    return this.bodyTag.classList.contains('overlay-open');
  }
  checkStatuForResize(_firstTime) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, 'ls-closed');
    } else {
      this.renderer.removeClass(this.document.body, 'ls-closed');
    }
  }
  mouseHover(_e) {
    const body = this.elementRef.nativeElement.closest('body');

    if (body.classList.contains('submenu-closed')) {
      this.renderer.addClass(this.document.body, 'side-closed-hover');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    }
  }
  mouseOut(_e) {
    const body = this.elementRef.nativeElement.closest('body');

    if (body.classList.contains('side-closed-hover')) {
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }

  checkIfMobile(): boolean {
    // Check localStorage first
    const isMobileStorage = localStorage.getItem("ismobile");
    if (isMobileStorage !== null) {
      return JSON.parse(isMobileStorage);
    }
    // Fallback to window width check
    return window.innerWidth < 1170;
  }

  /**
   * Load Near Miss menu items based on user's role
   * Role 1 (Admin): All menus
   * Role 2 (Manager): Near Misses, Tasks, Settings (Locations and Notifications only)
   * Role 3 (Task Owner): Near Misses, Tasks only
   */
  loadNearMissMenuByRole(): void {
    // Get user role_id from localStorage (from signin)
    const userJson = localStorage.getItem('currentUser') || localStorage.getItem('user') || '{}';
    const userData = JSON.parse(userJson);
    const userRoleId = userData.role_id || userData.roleId;

    console.log('Loading Near Miss menu for role_id:', userRoleId);

    // Start with all near miss routes
    let filteredRoutes = [...NEAR_MISS_ROUTES];

    if (userRoleId === 2) {
      // Manager: Show Near Misses and Tasks only (Settings should not be visible)
      filteredRoutes = filteredRoutes.filter(route => 
        route.title !== 'Settings'
      );
    } else if (userRoleId === 3) {
      // Task Owner: Show only Tasks (Near Misses should not be visible)
      filteredRoutes = filteredRoutes.filter(route => 
        route.title === 'Tasks' ||
        route.title === 'Home' ||
        route.title === 'Help'
      );
    }
    // else: Role 1 (Admin) or no role - show all menus

    this.sidebarItems = filteredRoutes;
    console.log('Filtered Near Miss menu items:', this.sidebarItems);
  }
}
